import React from 'react';
import PropTypes from 'prop-types';
import { UserShape } from '../../shapes';

export default class CommentPeopleMenuItem extends React.Component {

  static propTypes = {
    user: UserShape,
    highlighted: PropTypes.bool
  }

  render() {
    const cssClasses = (this.props.highlighted) ? 'comment-people-menu-item highlighted' : 'comment-people-menu-item';
    return(
      <div className={ cssClasses }>
        { this.userDisplayName() }
      </div>
    );
  }

  userDisplayName() {
    if (this.props.user.get('name')) {
      return `${ this.props.user.get('name') } (${ this.props.user.get('slug') })`;  
    } else {
      return this.props.user.get('slug');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/comments/comment_people_menu_item.jsx